import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'flex-center w-full gap-2'
  },
  variants: {},
  defaultVariants: {}
});
